import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('exploreData');
const type = createActionType('exploreData');

export const LOAD_QUERIES_FOR_ENTITY = apiType('LoadQueriesForEntity');
export const CREATE_QUERY = apiType('CreateQuery');
export const REFRESH_QUERY = type('RefreshQuery');
export const UPDATE_QUERY = apiType('UpdateQuery');
export const DELETE_QUERY = apiType('DeleteQuery');
export const EDIT_QUERY = type('EditQuery');
export const RENAME_QUERY = apiType('RenameQuery');

export const OPEN_EXPLORE = type('OpenExplore');
export const CLOSE_EXPLORE = type('CloseExplore');
export const PREVIEW_EXPLORATION = type('PreviewExploration');

/** @deprecated Use OPEN_EXPLORE */
export const OPEN_DIALOG = OPEN_EXPLORE;
/** @deprecated Use CLOSE_EXPLORE */
export const CLOSE_DIALOG = CLOSE_EXPLORE;
export const SELECT_CELL = type('SelectCell');
export const CHOOSE_VIZ = type('ChooseViz');
export const EXPLORATION_DOWNLOAD = type('ExplorationDownload');
export const INITIATE_EXPLORATION_DOWNLOAD = apiType('InitiateExplorationDownload');
export const EXPLORATION_DOWNLOAD_INITIATED = type('ExplorationDownloadInitiated');
export const EXPLORATION_DOWNLOAD_FAILED = type('ExplorationDownloadFailed');
export const CLOSE_QUERY_TAB = type('CloseQueryTab');
export const PROMOTE_EXPLORATION = apiType('PromoteExploration');
export const CREATE_EXPLORE_TRANSFORM = apiType('CreateExplorationTransform');
export const UPDATE_EXPLORE_TRANSFORM = apiType('UpdateExploreTransform');
export const COPY_EXPLORATIONS = type('CopyExplorations');
export const GET_DIMENSION_FILTER_VALUES = type('GetDimensionFilterValues');
export const SET_DIMENSION_FILTER_VALUES = type('SetDimensionFilterValues');
